import React, { Fragment, useState } from 'react'
import useRootStore from '@store/useRootStore'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
// icon
import { ArrowIco } from '@shared/Icon/ArrowIcon'
// css
import {
  Title,
  TitleWrap,
} from '@styles/base.style'
import { BackBtn } from '@styles/button.style'
import { GlobalStoreKey } from '@v2/constants/common'
import NavBar from '@views/Navbar'
import GuideTab from './GuideTab'
import { appScrollTo, loadOrReload } from '@utils/utils'

const Guide: React.FC = props => {
  const { authStore, routerStore, globalStore, logStore } = useRootStore()
  const visibleGuideBonusReceiveButton = authStore.isSignedIn && globalStore.visibleGuideBonusReceiveButton
  const visibleGuideBonusDelay = visibleGuideBonusReceiveButton && globalStore.visibleGuideBonusDelay
  const guideRewardTotalDelayTime = Number(globalStore.findGlobalSetting(GlobalStoreKey.GUIDE_BONUS_DELAY_TIME)?.value)
  const [currentGuideRewardDelayTime, setCurrentGuideRewardDelayTime] = useState(
    visibleGuideBonusDelay ? guideRewardTotalDelayTime : 0
  )

  let rewardDelayTimer

  useOnUnmount(() => {
    clearInterval(rewardDelayTimer)
  })

  useOnMount(() => {
    if (rewardDelayTimer) {
      clearInterval(rewardDelayTimer)
    }

    if (!authStore.isSignedIn) {
      loadOrReload('/')
    }

    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }

    if (visibleGuideBonusDelay) {
      let deltaTime = currentGuideRewardDelayTime - 1
      rewardDelayTimer = setInterval(() => {
        if (deltaTime <= 0) {
          globalStore.setVisibleGuideBonusDelay(false)
          clearInterval(rewardDelayTimer)
        }
        deltaTime -= 1
        setCurrentGuideRewardDelayTime(deltaTime)
      }, 1000)
    }

  })

  return (
    <Fragment>
      <TitleWrap className="title-wrap sticky guide-tit">
        {isMobile && (
          <BackBtn onClick={() => {
            logStore.writeButtonLog({ pageId: 'a060', buttonId: '001' }).catch(console.error)
            routerStore.goBack()
          }}>
            <ArrowIco/>
          </BackBtn>
        )}
        {!isMobile && <Title className="title">TIPs</Title>}
      </TitleWrap>

      <GuideTab/>

      {isMobile && <NavBar key="Guide:NavBar"/>}
    </Fragment>
  )
}

export default observer(Guide)
